import { Field, InputType, ObjectType } from 'type-graphql'
import { Address } from '../address/Address'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
@InputType('ContactInput')
export class Contact {
  @Field(() => Address)
  @Prop({ type: Address })
  address1: Address

  @Field(() => String)
  @Prop({ type: String })
  email: string

  @Field(() => String)
  @Prop({ type: String })
  person: string

  @Field(() => String)
  @Prop({ type: String })
  phone: string

  @Field(() => String)
  @Prop({ type: String })
  url: string
}
